import React, { useState, useEffect } from "react";
import { UserInfoCard } from "src/components//reports/cards";
import { CardStyled, CardsGroupContainer } from "./card.styled";
import { Descriptions, DescriptionsProps, Skeleton } from "antd";
import { CardTitle, CardText } from "../../../components/reports/cards/report-cards.styled";
import { useMediaQuery } from "src/hooks";
import { useSelector } from "react-redux";
import { RootState } from "src/core/store/store";
import { getBoxPage } from "../../../Api/content";
import { useLocale } from "../../../i18n/localeContext";
import { StrapiError } from "../../../pages/StrapiError";

const CardsGroup = ({
  extraContent,
  userInfoCustom,
}: {
  extraContent: React.ReactNode;
  userInfoCustom?: any;
}) => {
  const { locale } = useLocale();
  const [boxPage, setBoxPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const windowWidth = useMediaQuery("(min-width: 480px)");
  const { userInfo } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setBoxPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);
    getBoxPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setBoxPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setBoxPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setBoxPage(null);
      }}
    />;
  }

  const mobileItems: DescriptionsProps["items"] = [
    {
      key: "1",
      label: <CardTitle>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxPage?.id_code || "ID")}</CardTitle>,
      children: <CardText>{userInfoCustom ? userInfoCustom?.id : userInfo?.id}</CardText>,
    },
    {
      key: "2",
      label: <CardTitle>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxPage?.name || "Nombre")}</CardTitle>,
      children: (
        <CardText>{userInfoCustom ? userInfoCustom?.fullName : userInfo?.fullName}</CardText>
      ),
    },
  ];

  return (
    <>
      {windowWidth ? (
        <CardsGroupContainer>
          <UserInfoCard
            nombre={`${userInfoCustom ? userInfoCustom?.fullName : userInfo?.fullName}`}
            id={userInfoCustom ? userInfoCustom?.id : userInfo?.id}
            extraContent={extraContent}
          />
        </CardsGroupContainer>
      ) : (
        <>
          {extraContent}
          <CardStyled>
            <Descriptions layout="vertical" size="middle" items={mobileItems} />
          </CardStyled>
        </>
      )}
    </>
  );
};

export default CardsGroup;
